// extracted by mini-css-extract-plugin
module.exports = {"container":"HelpdeskHeader_container__1cK22"};